<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar title="开票抬头" left-arrow @click-left="$router.go(-1)" />
		</div>
		<div style="height: 46px;"></div>
		<div class='title_box'>
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
				<div v-for='item in list' class='title_list ui-flex' @click="edit(item.id)">
					<div class='title_info ui-flex-1'>
						<div class='title_name'>{{item.receiverCompanyName}}</div>
						<div class='title_tax'>税号：{{item.receiverCompanyTax}}</div>
					</div>
					<div class='title_eidt'>
						<van-icon name="edit" size="18" color="#999"/>
					</div>
				</div>
			</van-list>
		</div>

		<div style='height:96px;'></div>
		<div class='bottom_fixed'>
			<van-button type="primary" icon="plus" color="#2f86f6" round block to="/home/title/add">添加</van-button>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				pageNo : 1,
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				this.loading = true;
				this.$get("/gtb/home/invoiceReceiver.html", { pageNo : this.pageNo }).then(res => {
					this.loading = false;
					if( res.success ){
						const pList = res.pList.pageRecords;
						this.list = this.list.concat(pList);
						this.pageNo = this.pageNo + 1;
						this.finished = this.list.length >= res.pList.totalSize;
					}
				}).catch(error=>{
					this.loading = false;
				});
			},
			edit(id){
				this.$router.push('/home/title/edit?id=' + id);
			}
		},
	};
</script>

<style scoped>
	.title_box{padding:16px; }
	.title_list{ background: #fff; border-radius: 9px; margin-bottom: 10px; padding: 16px;}
	.title_info{ margin-right: 10px;}
	.title_name{ font-weight: bold; font-size: 16px;}
	.title_tax{ color: #888;font-size: 12px; padding-top: 6px;}
	.title_eidt{ display:flex;align-items: center;}
	.bottom_fixed{ position: fixed; width: 100%; bottom: 0; padding: 16px;}
</style>
